module.exports = __webpack_public_path__ + "assets/tDbI2oqRg1oM3QBjjcaDkOr9rAU-df738a.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/tDbI2oqRg1oM3QBjjcaDkOr9rAU.woff2
// module id = 863
// module chunks = 2